<div id="chat-widget-close-message" class="chatWidgetClose noPrint">
    <div class="chat-widget-close-message">
        <p x-text="closeContent1"></p>
        <p x-text="closeContent2"></p>
        <p x-text="closeContent3"></p>
        <p>Bis bald!</p>
    </div>

    <div id="chat-widget-buttons" class="chat-widget-link-bar">
        <button @click="closeWidget"
                title="Schliessen"
                id="close-widget-button"
                class="chat-widget-link close-widget-button">
            Schliessen
        </button>

        <button @click="printChatHistory"
                x-show="printChatHistoryVisibility"
                title="Chatverlauf drucken"
                id="chat-history-button"
                class="chat-widget-link chat-history-button">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewBox="0 0 44 42" class="chat-widget-print-chat">
                <path d="M8.5 41.6a1 1 0 0 1-.9-1v-8.9L1 31.6a1 1 0 0 1-.9-1v-17a1 1 0 0 1 1-1h6.6V1a1 1 0 0 1 1-.9h26.9a1 1 0 0 1 .9 1v11.7H43a1 1 0 0 1 .9.9v17a1 1 0 0 1-.9 1l-6.7.1v9a1 1 0 0 1-1 .9zm1-1.8h25V26h-25zm26-15.5a1 1 0 0 1 .9.9v4.7l5.8-.1V14.5H1.8v15.3h5.8v-4.6a1 1 0 0 1 1-1zm-26-11.8h25V1.8h-25zm2 25.9a1.2 1.2 0 1 1 0-2.4h21a1.2 1.2 0 0 1 0 2.4zm0-3.7a1.2 1.2 0 0 1 0-2.4h21a1.2 1.2 0 1 1 0 2.4zM28.7 18a1.7 1.7 0 1 1 3.4-.8 1.7 1.7 0 0 1-3.4.8m8.1-.4a1.7 1.7 0 1 1 3.5 0 1.7 1.7 0 0 1-3.5 0m-4 0a1.7 1.7 0 1 1 3.4 0 1.7 1.7 0 0 1-3.4 0"/>
            </svg>
            <span>Chatverlauf anzeigen</span>
        </button>

    </div>
</div>

<div id="chat-widget-print-content" class="printOnly"></div>